module.exports = __webpack_public_path__ + "img/4diamonds.7ef3856a.jpg";